// Time categories are lists, and a list is given to a person or to a role. The shop has its
// list (cleaning, a blade change); the owner has his own (Build, Install, Design & Engineering,
// Sales & Pipeline, On-Business, Admin / Overhead). Which list someone picks from when logging
// time is worked out here; the lists and who gets them are data.

export interface TimeCategoryAssignment {
  list_id: string;
  role?: string | null;
  user_id?: string | null;
}

export interface TimeCategory {
  id: string;
  list_id: string | null;
  name: string;
  sort?: number | null;
}

export interface Person {
  id: string;
  role: string | null;
}

/**
 * The lists this person logs time against. A list given to the person by name wins over the
 * lists given to their role. Null means nobody has assigned them a list.
 */
export function timeListsFor(person: Person, assignments: TimeCategoryAssignment[]): string[] | null {
  const own = assignments.filter((a) => a.user_id && a.user_id === person.id).map((a) => a.list_id);
  if (own.length > 0) return [...new Set(own)];
  const role = String(person.role ?? '').trim().toLowerCase();
  const byRole = role === '' ? [] : assignments.filter((a) => !a.user_id && String(a.role ?? '').trim().toLowerCase() === role).map((a) => a.list_id);
  return byRole.length > 0 ? [...new Set(byRole)] : null;
}

/**
 * The categories this person sees, in order. With no list assigned they see every category,
 * so a missing assignment never leaves someone unable to log time.
 */
export function timeCategoriesFor<C extends TimeCategory>(person: Person, assignments: TimeCategoryAssignment[], categories: C[]): C[] {
  const lists = timeListsFor(person, assignments);
  const mine = lists === null ? categories : categories.filter((c) => c.list_id !== null && lists.includes(c.list_id));
  return [...mine].sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0) || a.name.localeCompare(b.name));
}
